import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

function CopyButton({ text }) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', background: 'rgba(255,255,255,0.2)', borderRadius: '4px', padding: '2px 8px', marginLeft: '6px', fontFamily: 'monospace', fontWeight: 'bold' }}>
      {text}
      <button
        onClick={handleCopy}
        style={{ marginLeft: '8px', background: 'rgba(255,255,255,0.3)', border: 'none', borderRadius: '3px', color: 'inherit', cursor: 'pointer', padding: '2px 6px', fontSize: '12px' }}
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </span>
  )
}

export default function RingroundSnackbar() {
  const alert = useSelector(s => s.local.alert)
  const act = useAct()

  function handleClose() {
    act.local.upsert({ alert: null })
  }
  if (!alert) return null

  return (
    <Snackbar
      open={true}
      autoHideDuration={alert.persist ? null : alert.duration || 6000}
      onClose={handleClose}
      anchorOrigin={alert.position || { vertical: 'bottom', horizontal: 'center' }}
      style={{ margin: alert.margin || 'inherit' }}
    >
      <Alert onClose={handleClose} severity={alert.severity}>
        {alert.message}
        {alert.copyableText && <CopyButton text={alert.copyableText} />}
      </Alert>
    </Snackbar>
  )
}
